export enum eOrderType {
    notSet = "NotSet",
    lien = "Lien",
    renewal = "Renewal",
    discharge = "Discharge",
    amendment = "Amendment",
    debtorSearch = "DebtorSearch",
    assetSearch = "AssetSearch",
    repairLien = "RepairLien",
    basicRenewal = "BasicRenewal",
    basicDischarge = "BasicDischarge",
    certifiedDebtorSearch = "CertifiedDebtorSearch",
    businessSearch = "BusinessSearch",
    businessReport = "BusinessReport",
    assetMultiSearch = "AssetMultiSearch",
    assignment = "Assignment",
    registrationNumberSearch = "RegistrationNumberSearch",
    reregistration = "Reregistration",
    ultimateBeneficialOwnershipReport = "UltimateBeneficialOwnershipReport",
    pepsAndSanctions = "PEPsAndSanctions",
    landTitleSearch = "LandTitleSearch",
    debtorMultiSearch = "DebtorMultiSearch",
    knowYourCustomer = "KnowYourCustomer"
}

export enum eOrderTypeGroup {
    PPSARegistration = "PPSARegistration",
    PPSASearch = "PPSASearch",
    BasicPPSARegistration = "BasicPPSARegistration",
    PPSAChangeManagement = "PPSAChangeManagement",
    BusinessSearch = "BusinessSearch",
    LandServices = "LandServices",
    KnowYourCustomer = "KnowYourCustomer"
}

export enum ePartyType {
    businessDebtor = "BusinessDebtor",
    individualDebtor = "IndividualDebtor",
    businessSecuredParty = "BusinessSecuredParty",
    individualSecuredParty = "IndividualSecuredParty",
    businessRegisteringAgent = "BusinessRegisteringAgent",
    individualRegisteringAgent = "IndividualRegisteringAgent",
    businessDealer = "BusinessDealer",
    individualDealer = "IndividualDealer",
    individualAttestor = "IndividualAttestor",
    individualBeneficialOwner = "IndividualBeneficialOwner",
    businessBeneficialOwner = "BusinessBeneficialOwner",
    individualSigningAuthority = "IndividualSigningAuthority",
    businessShareholder = "BusinessShareholder",
    individualShareholder = "IndividualShareholder"
}

export enum eAssetType {
    None = 0,
    MotorVehicle = 1,
    Trailer = 2,
    Boat = 3,
    MobileHome = 4,
    OutboardMotor = 5,
    AircraftRegisteredInCanada = 6,
    AircraftNonRegisteredInCanada = 7,
    ManufacturedHome = 8,
    FarmVehicle = 9,
    Motorcycle = 10,
    Bus = 11,
    MiniBus = 12,
    Taxi = 13,
    AllTerrainVehicle = 14,
    SnowmobilePost1988 = 15,
    PassengerVehicle = 16,
    EmergencyVehicle = 17,
    CommercialVehicle = 18,
    Other = 19,
    AircraftCanada = 20,
    AircraftForeign = 21,
    AircraftAirframeRegisteredInCanada = 22,
    AircraftAirframeNotRegisteredInCanada = 23,
    Aircraft = 24,
    AircraftDOT = 25,
    AircraftSerial = 26,
    TrailerOrSemiTrailer = 27,
    MotorHome = 28,
}

export const assetTypeLookup: { [key: string]: eAssetType; } = {
    MotorVehicle: eAssetType.MotorVehicle,
    Trailer: eAssetType.Trailer,
    Boat: eAssetType.Boat,
    MobileHome: eAssetType.MobileHome,
    OutboardMotor: eAssetType.OutboardMotor,
    AircraftRegisteredInCanada: eAssetType.AircraftRegisteredInCanada,
    AircraftNonRegisteredInCanada: eAssetType.AircraftNonRegisteredInCanada,
    ManufacturedHome: eAssetType.ManufacturedHome,
    FarmVehicle: eAssetType.FarmVehicle,
    Motorcycle: eAssetType.Motorcycle,
    Bus: eAssetType.Bus,
    MiniBus: eAssetType.MiniBus,
    Taxi: eAssetType.Taxi,
    AllTerrainVehicle: eAssetType.AllTerrainVehicle,
    SnowmobilePost1988: eAssetType.SnowmobilePost1988,
    PassengerVehicle: eAssetType.PassengerVehicle,
    EmergencyVehicle: eAssetType.EmergencyVehicle,
    CommercialVehicle: eAssetType.CommercialVehicle,
    Other: eAssetType.Other,
    AircraftCanada: eAssetType.AircraftCanada,
    AircraftForeign: eAssetType.AircraftForeign,
    AircraftAirframeRegisteredInCanada: eAssetType.AircraftAirframeRegisteredInCanada,
    AircraftAirframeNotRegisteredInCanada: eAssetType.AircraftAirframeNotRegisteredInCanada,
    Aircraft: eAssetType.Aircraft,
    AircraftDOT: eAssetType.AircraftDOT,
    AircraftSerial: eAssetType.AircraftSerial,
    TrailerOrSemiTrailer: eAssetType.TrailerOrSemiTrailer,
    MotorHome: eAssetType.MotorHome
};

export enum eOrderStatusType {
    draft = "Draft",
    pending = "Pending",
    complete = "Complete",
    invalid = "Invalid",
    requestedAtRegistry = "RequestedAtRegistry",
    failedAutomation = "FailedAutomation",
    manualFulfillment = "ManualFulfillment",
    outOfRegistryHours = "OutOfRegistryHours",
    awaitingHighVolumeResults = "AwaitingHighVolumeResults",
    historicalDraft = "HistoricalDraft",
    historical = "Historical",
    registryOutage = "RegistryOutage",
    exception = "Exception",
    errorCorrection = "ErrorCorrection",
    documentProcessing = "DocumentProcessing",
    cancelled = "Cancelled",
    documentReProcessing = "DocumentReProcessing",
    staged = "Staged",
    awaitingExternalInformation = "AwaitingExternalInformation",
    externalErrorCorrection = "ExternalErrorCorrection",
    identityVerification = "IdentityVerification"
}

export const orderStatusTypeLookup: { [key: number]: string; } = {
    1: "Draft",
    2: "Pending",
    3: "Complete",
    4: "Invalid",
    5: "RequestedAtRegistry",
    6: "FailedAutomation",
    7: "ManualFulfillment",
    8: "OutOfRegistryHours",
    9: "AwaitingHighVolumeResults",
    10: "HistoricalDraft",
    11: "Historical",
    12: "RegistryOutage",
    13: "Exception",
    14: "ErrorCorrection",
    15: "DocumentProcessing",
    16: "Cancelled",
    17: "DocumentReProcessing",
    18: "Staged",
    19: "AwaitingExternalInformation",
    20: "ExternalErrorCorrection",
    21: "IdentityVerification"
};

export enum eGeneration {
    Jr = "Jr.",
    Sr = "Sr.",
    Esquire = "Esquire",
    First = "First",
    Second = "Second",
    Third = "Third",
    Fourth = "Fourth",
    Fifth = "Fifth",
    Sixth = "Sixth",
    Elder = "Elder",
    Younger = "Younger"
}

export enum eMatSelectAppearance {
    legacy = "legacy",
    standard = "standard",
    fill = "fill",
    outline = "outline"
}

export enum eLogSeverity {
    Debug = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Critical = 4
}

export enum eUserType {
    Api = "Api",
    Portal = "Portal",
    Agent = "Agent",
}

export enum eQCFormType {
    none = 0,
    RHa = "RHa",
    RDd = "RDd",
    RDe = "RDe",
    RG34 = "RG34",
    RG41 = "RG41",
    RV = "RV",
    RRa = "RRa",
    RHf = "RHf",
    RDf = "RDf",
    RG80 = "RG80",
    RE = "RE",
    RDc = "RDc",
    RDb = "RDb",
    RG14 = "RG14",
    RDa = "RDa",
    RG13 = "RG13"
}

export enum eSystemEventType {
    ScheduledMaintenance = 1,
    RegistryOutage = 2,
    GeneralNotice = 3
}

export enum eOrderChangeOperation {
    Replace = "Replace",
    Add = "Add",
    Remove = "Remove"
}

export enum eDatabaseType {
    Primary = 1,
    Customer = 2
}

export enum eAmendmentType {
    change = "Change",
    correction = "Correction"
}

export enum eDischargeType {
    totalDischarge = "TotalDischarge",
    agreementToDischarge = "AgreementToDischarge"
}

export enum eEnvelopeStatusType {
    error = "Error",
    open = "Open",
    sealed = "Sealed",
    imported = "Imported",
    resultsPending = "ResultsPending",
    complete = "Complete",
    documentProcessing = "DocumentProcessing"
}

export enum eEnvelopeType {
    ppsaRegistration = "PpsaRegistration",
    hubReport = "HubReport"
}

export enum eBatchState {
    draft = "Draft",
    Normalization = "Normalization",
    preProcessing = "PreProcessing",
    processingFailed = "ProcessingFailed",
    processing = "Processing",
    stopped = "Stopped",
    completed = "Complete",
    review = "Review",
    audit = "Audit",
    awaitingResults = "AwaitingResults",
    finalizing = "Finalizing"
}

export enum eBatchType {
    historicalLien = "HistoricalLien",
    lien = "Lien",
    renewal = "Renewal",
    discharge = "Discharge",
    assetSearch = "AssetSearch",
    debtorSearch = "DebtorSearch",
    basicDischarge = "BasicDischarge",
    basicRenewal = "BasicRenewal",
    caBusinessSearch = "CABusinessSearch",
    caBusinessReport = "CABusinessReport",
    archiveImport = "ArchiveImport",
    vinSight = "VinSight",
    registrationNumberSearch = "RegistrationNumberSearch",
    ultimateBeneficialOwnershipReport = "UltimateBeneficialOwnershipReport",
    usBusinessSearch = "USBusinessSearch",
    usBusinessReport = "USBusinessReport"
}

export enum eResultState {
    noResult = "NoResult",
    rawDocument = "RawDocument",
    parsedDocument = "ParsedDocument",
    resultsOverflow = "ResultsOverflow"
}

export enum eResultStateID {
    noResult = 1,
    rawDocument = 2,
    parsedDocument = 3,
    resultsOverflow = 4
}

export enum eRegistryForm {
    ontarioChangesCorrectionsOmissionsPPSA = "OntarioChangesCorrectionsOmissionsPPSA",
    ontarioRenewalPPSA = "OntarioRenewalPPSA",
    ontarioFullDischargePPSA = "OntarioFullDischargePPSA",
    ontarioAssignmentBySecuredPartyPPSA = "OntarioAssignmentBySecuredPartyPPSA",
    ontarioTransferByDebtorPPSA = "OntarioTransferByDebtorPPSA",
    ontarioPartialDischargePPSA = "OntarioPartialDischargePPSA",
    ontarioAssignmentOfPartOfTheCollateralPPSA = "OntarioAssignmentOfPartOfTheCollateralPPSA",
    ontarioTransferOfPartOfTheCollateralPPSA = "OntarioTransferOfPartOfTheCollateralPPSA",
    ontarioSubordinationPostponementPPSA = "OntarioSubordinationPostponementPPSA",
    ontarioBlankFormPPSA = "OntarioBlankFormPPSA",
    quebecRHa = "QuebecRHa", //Lien
    quebecRDd = "QuebecRDd", //Lien
    quebecRDe = "QuebecRDe", //Lien
    quebecRG34 = "QuebecRG34", //Amendment (Change)
    quebecRG41 = "QuebecRG41", //Renewal
    quebecRV = "QuebecRV", //Discharge
    quebecRRa = "QuebecRRa", //Amendment (Correction)
    quebecRHf = "QuebecRHf", //Renewal
    quebecRDf = "QuebecRDf", //Lien
    quebecRG80 = "QuebecRG80", //Secured Party Transfer
    quebecRE = "QuebecRE", //Partial Discharge
    quebecRG14 = "QuebecRG14", //Assignment of Rank
    quebecRDb = "QuebecRDb", //Lien
    quebecRDc = "QuebecRDc", //Lien
    quebecRDa = "QuebecRDa", //Lien
    quebecRG13 = "QuebecRG13", //Assignment
    saskatchewanNotations = "SaskatchewanNotations",
    saskatchewanDebtor = "SaskatchewanDebtor",
    saskatchewanSecuredParty = "SaskatchewanSecuredParty",
    saskatchewanGeneralProperty = "SaskatchewanGeneralProperty",
    saskatchewanSerialProperty = "SaskatchewanSerialProperty",
    saskatchewanRIN = "SaskatchewanRIN",
}

export enum eFinanceType {
    Loan = 1,
    Lease = 2
}

export enum eRouteOnePartyType {
    Lender = 1,
    Dealer = 2
}

export enum eValidationLogType {
    Error = "Error",
    Warning = "Warning",
    Notice = "Notice"
}

export enum eBusinessSearchCriteriaType {
    None = 0,
    Name = 1,
    Number = 2
}

export enum eBusinessSearchCriteriaTypeString {
    None = "None",
    Name = "Name",
    Number = "Number"
}

export enum eRequestedReportType {
    Orders = "Orders",
    SLA = "SLA",
    UnpaidInvoices = "UnpaidInvoices",
    CustomerPricing = "CustomerPricing",
    PricingTiers = "PricingTiers",
    PricingComparison = "PricingComparison",
    FeeSummary = "FeeSummary",
    Revenue = "Revenue"
}

export enum eSerialNumberActivityLevel {
    Green = "Green",
    Yellow = "Yellow",
    Red = "Red"
}

export enum eFeeType {
    service = "Service",
    disbursement = "Disbursement",
    agent = "Agent",
    serviceRebate = "ServiceRebate",
    disbursementRebate = "DisbursementRebate",
    agentRebate = "AgentRebate"
}

export enum eAuditState {
    pending = "Pending",
    passed = "Passed",
    regHubFailed = "RegHubFailed",
    customerFailed = "CustomerFailed"
}

export enum eBatchValidationType {
    attachment = "Attachment",
    headers = "Headers",
    data = "Data"
}

export enum ePartyLinkType {
    notApplicable = "NotApplicable",
    association = "Association"
}

export enum ePartySubType {
    assignor = "Assignor",
    assignee = "Assignee",
    transferor = "Transferor",
    transferee = "Transferee"
}

export enum eSummaryEntityType {
    debtor = "Debtor",
    securedParty = "SecuredParty",
    dealer = "Dealer",
    undeterminedParty = "UndeterminedParty",
    otherParty = "OtherParty",
    serialCollateral = "SerialCollateral",
    assignor = "Assignor",
    assignee = "Assignee",
    transferor = "Transferor",
    transferee = "Transferee"
}

export enum eSummaryTextBlockType {
    generalCollateral = "GeneralCollateral",
    additionalInformation = "AdditionalInformation",
    amendmentDetails = "AmendmentDetails"
}

export enum eParsedSearchResultType {
    exact = "Exact",
    similar = "Similar",
    unparsed = "Unparsed",
    notSpecified = "NotSpecified"
}

export enum eNormalizedStatus {
    active = "Active",
    inactive = "Inactive",
    notProvided = "NotProvided"
}

export enum eNormalizedEntityType {
    businessName = "BusinessName",
    corporation = "Corporation",
    other = "Other"
}

export enum eNormalizedAddressType {
    registeredAddress = "RegisteredAddress",
    mailAddress = "MailAddress",
    other = "Other",
    homeJurisdictionAddress = "HomeJurisdictionAddress",
    homeAddress = "HomeAddress",
    deliveryAddress = "DeliveryAddress",
    headOfficeAddress = "HeadOfficeAddress",
    placeOfBusiness = "PlaceOfBusiness",
    recordsAddress = "RecordsAddress",
    none = "None"
}

export enum eNormalizedPartyType {
    debtor = "Debtor",
    securedParty = "SecuredParty",
    dealer = "Dealer",
    registeringAgent = "RegisteringAgent",
    director = "Director",
    officer = "Officer",
    shareholder = "Shareholder",
    agent = "Agent",
    proprietor = "Proprietor",
    partner = "Partner",
    nameOwner = "NameOwner",
    beneficialOwner = "BeneficialOwner",
    significantControl = "SignificantControl",
    powerOfAttorney = "PowerOfAttorney",
    registrant = "Registrant",
    declarant = "Declarant",
    attorney = "Attorney",
    other = "Other",
    undetermined = "Undetermined"
}

export enum eNormalizedRelationshipType {
    other = "Other",
    otherName = "OtherName",
    currentName = "CurrentName",
    previousName = "PreviousName",
    translatedName = "TranslatedName",
    amalgamatedFrom = "AmalgamatedFrom",
    amalgamatedTo = "AmalgamatedTo",
    businessName = "BusinessName",
    tradePartnerName = "TradePartnerName",
    none = "None"
}

export enum eSearchJurisdictionState {
    None = "None",
    Pending = "Pending",
    Failed = "Failed",
    Complete = "Complete",
    InterimNoResults = "InterimNoResults"
}

export enum eActivityType {
    Registration = "Registration",
    Discharge = "Discharge",
    Search = "Search",
    NotFound = "NotFound",
    CrimeCheckHit = "CrimeCheckHit",
    CrimeCheckClear = "CrimeCheckClear",
    InRepossession = "InRepossession"
}

export enum eActivitySubType {
    lien = "Lien",
    repairLien = "RepairLien"
}

export enum eTimelineEventType {
    Known = "Known",
    Inferred = "Inferred"
}

export enum eAccessLevel {
    Hidden = "Hidden",
    ViewOnly = "ViewOnly",
    DraftOnly = "DraftOnly",
    Full = "Full"
}

export enum eAnswerType {
    test = "Text",
    datetime = "DateTime",
    boolean = "Boolean"
}

export enum eAnswerControl {
    textField = "TextField",
    textBox = "TextBox",
    radioButton = "RadioButton",
    dropdownList = "DropdownList",
    checkbox = "Checkbox"
}

export enum eDocumentType {
    pdf = "PDF",
    text = "Text",
    xml = "XML",
    html = "HTML",
    json = "JSON",
    csv = "CSV"
}

export const answerControlRequiresOptions: Record<eAnswerControl, boolean> = {
    [eAnswerControl.textField]: false,
    [eAnswerControl.textBox]: false,
    [eAnswerControl.radioButton]: true,
    [eAnswerControl.dropdownList]: true,
    [eAnswerControl.checkbox]: false
};

export enum eShareholderType {
    business = "Business",
    individual = "Individual"
}

export enum eBusinessSearchScope {
    Full = "Full",
    Fast = "Fast"
}

export enum ePartnerships {
    None = 0, //0
    Equifax = 1 << 0, //1
    Innovatec = 1 << 1, //2
}

export enum eReportColumns {
    None = 0,
    RegistrationNumber = 1 << 0,
    ONFileNumber = 1 << 1,
    RegistrationDate = 1 << 2,
    ExpiryDate = 1 << 3,
    Amount = 1 << 4,
    PrimaryDebtor = 1 << 5,
    PrimaryDebtorAddress = 1 << 6,
    PrimarySecuredParty = 1 << 7,
    PrimarySecuredPartyAddress = 1 << 8,
    SerialNumber = 1 << 9,
    Make = 1 << 10,
    Model = 1 << 11,
    Year = 1 << 12,
    AllPartyNames = 1 << 13,
    AnyPEPsFound = 1 << 14,
    AnySanctionsFound = 1 << 15,
    UBOEntityName = 1 << 16,
    UBOEntityNumber = 1 << 17,
    AttestorName = 1 << 18,
    AttestorEmail = 1 << 19,
    OriginalRegistrationNumber = 1 << 20,
    OriginalRegistrationDate = 1 << 21,
    ReturnedToAttestor = 1 << 22,
    AttestationTemplate = 1 << 23
}

export enum eIdentityVerificationSource {
    EfxAmlSingleSource = "EfxAmlSingleSource",
    EfxAmlDualSourceFirst = "EfxAmlDualSourceFirst",
    EfxAmlDualSourceSecond = "EfxAmlDualSourceSecond",
    EfxDvs = "EfxDvs",
    EntrustDvs = "EntrustDvs",
    Telephone = "Telephone",
    TuCreditBureau = "TuCreditBureau",
    TuCreditBureauFirst = "TuCreditBureauFirst",
    TuCreditBureauSecond = "TuCreditBureauSecond"
}

export enum eIdentityVerificationResult {
    Pending = "Pending",
    Success = "Success",
    Fail = "Fail",
    NA = "NA",
    Expired = "Expired",
    NoHit = "NoHit",
    Review = "Review",
    Hit = "Hit",
    Blocked = "Blocked"
}

export enum eIdentityVerificationValues {
    Match = "Match",
    NoMatch = "NoMatch",
    PartialMatch = "PartialMatch",
    NotProvided = "NotProvided",
    NotChecked = "NotChecked",
    NotApplicable = "NotApplicable",
    NotFound = "NotFound",
    Pass = "Pass",
    Fail = "Fail",
    True = "True",
    False = "False",
}

export enum eLegalDescriptionType {
    Urban = "Urban",
    Rural = "Rural"
}

export enum eHubReportType {
    ultimateBeneficialOwnership = "UltimateBeneficialOwnership"
}

export enum eGrafanaEnvironments {
    dev = "46be00f5-6490-4ce4-810c-ce32459baf0d",
    uat = "119b0609-7eeb-4300-9d24-208c60802962",
    prod = "7cb832bb-7021-4cc2-ab80-d2ae16027235"
}

export enum ePepsAndSanctionListGroup {
    Primary = "Primary",
    Secondary = "Secondary"
}

export enum eUnregisteredEntityOwnerType {
    Shareholder = "Shareholder",
    Trustee = "Trustee",
    Beneficiary = "Beneficiary",
    Settlor = "Settlor",
    Partner = "Partner",
    Owner = "Owner",
    Director = "Director",
    Officer = "Officer",
    ControllingIndividual = "ControllingIndividual",
    UltimateBeneficialOwner = "UltimateBeneficialOwner",
    PersonWithSignificantControl = "PersonWithSignificantControl",
    Executor = "Executor",
    Protector = "Protector",
    Nominee = "Nominee",
    Other = "Other"
}

export enum eAlertTypeGroup {
    SerialNumber = "SerialNumber",
    Individual = "Individual",
    Business = "Business"
}

export enum eAlertType {
    SerialNumber_PPSAFiling = "SerialNumber_PPSAFiling",
    SerialNumber_PPSASearch = "SerialNumber_PPSASearch",
    Individual_PPSAFiling = "Individual_PPSAFiling",
    Individual_PPSASearch = "Individual_PPSASearch",
    Business_PPSAFiling = "Business_PPSAFiling",
    Business_PPSASearch = "Business_PPSASearch"
}

export enum eAlertStatus {
    New = "New",
    Assigned = "Assigned",
    Resolved = "Resolved"
}

export enum eAlertSeverity {
    Low = "Low",
    Medium = "Medium",
    High = "High",
    Severe = "Severe"
}

export enum eAlertHubEventType {
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted"
}

export enum eTrackedAlertTypeEntity {
    SerialNumber = "SerialNumber",
    Individual = "Individual",
    Business = "Business"
}

// Mirrors RegHubUtilities ENUMS.eAlertActionType; values are the member names the API sends
export enum eAlertActionType {
    PPSAAssetSearch = "PPSAAssetSearch",
    VinSight = "VinSight"
}